import React, { useState, useRef, useEffect } from "react";
import { FaWhatsapp, FaRegPaperPlane, FaTimes } from "react-icons/fa";
import { BsLightningFill, BsFillChatFill } from "react-icons/bs";
import "../styles/FloatingChat.css";

// Your WhatsApp number (official KKB contact)
const WA_NUMBER = "919843222262";

// Initial bot greeting (shown when chat opens)
const BOT_GREETING =
  "Welcome to K.K. Balusamy & Co! I'm your KKB assistant. How can I help you find the perfect Lungi today?";

export default function FloatingChat() {
 

  return (
    <div className="kkb-chat-wrapper">
      {/* Action Buttons - Fixed to right side */}
      <div className="kkb-fab-container">
        <a
          href={`https://wa.me/${WA_NUMBER}?text=Hi KKB Store, I'm interested in your products.`}
          target="_blank"
          rel="noreferrer"
          className="kkb-fab whatsapp"
          title="Chat on WhatsApp"
          aria-label="Chat on WhatsApp"
        >
          <FaWhatsapp size={28} />
        </a>
      </div>
    </div>
  );
}
